import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    capturedImage: null,
};

const profilePhotoSlice = createSlice({
  name: "profilePhoto",
  initialState,
  reducers: {
    setCapturedImage: (state, action) => {
      state.capturedImage = action.payload;
    },
  },
});

export const { 
    setCapturedImage 
} = profilePhotoSlice.actions;
export default profilePhotoSlice.reducer;